import React from 'react';
import { DashboardPieChart } from './DashboardPieChart';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { closeReportModal, showReportModalHandler } from 'src/store/slices/callSlice';
import ModalComponent from 'src/components/Modals/Modals';
import { RootState } from 'src/store/store';
import CallReportModal from 'src/components/Modals/CallReportModal';
import { useTranslation } from 'react-i18next';

const CallDashboard: React.FC = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation("common");
  const handleDownloadReport = () => {
    dispatch(showReportModalHandler());
  };
  const handleCloseReportModal = () => {
    dispatch(closeReportModal());
  }
  const showReportModal = useSelector(
    (state: RootState) => state.calls.showReportModal
  );
  return (<>
    <div>
      <div className="container-fluid p-0">
        <div className="mb-3 d-flex justify-content-end">
          <button
            type="button"
            className="btn btn-primary d-flex align-items-center justify-content-between"
            onClick={handleDownloadReport}
          >
            <span className="text-nowrap">Download Report &nbsp;</span>
            <FontAwesomeIcon icon={faDownload} />
          </button>
        </div>
        <div>
          <DashboardPieChart />
        </div>
      </div>
    </div>
    <ModalComponent
      isOpen={showReportModal}
      onClose={handleCloseReportModal}
      modalHeading={t("common.reportDetails")}
      size="lg"
    >
      <CallReportModal />
    </ModalComponent>
  </>

  );
};

export default CallDashboard;